// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0-beta.51e39ccfa',
  revision: '51e39ccfa',
  branch: 'develop',
  date: 'Thu, 01 Oct 2026 16:27:59 GMT'
};